import { Reveal, Overline } from "@/components/site/Reveal";
import { IMAGES } from "@/lib/site";
import { useLang } from "@/context/LanguageContext";

export const Mission = () => {
  const { t } = useLang();
  const chapters = t("mission.chapters");
  return (
    <section id="mission" data-testid="mission-section" className="relative bg-[#F8F9FA] py-24 md:py-36">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8 items-start">
          <div className="md:col-span-5 md:sticky md:top-28">
            <Reveal>
              <Overline>{t("mission.overline")}</Overline>
              <h2 className="mt-6 font-display text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-[#0A1128]">
                {t("mission.title")}
              </h2>
              <p className="mt-8 text-base md:text-lg text-[#4B5563] leading-relaxed max-w-md">{t("mission.sub")}</p>
              <div className="mt-10 relative w-full aspect-[4/5] max-w-sm">
                <img src={IMAGES.cultureDancing} alt="Haitian culture and celebration" className="w-full h-full object-cover" />
                <div className="absolute -bottom-4 -right-4 w-full h-full border border-[#D4AF37] -z-0" />
              </div>
            </Reveal>
          </div>

          <div className="md:col-span-7 md:col-start-6">
            {chapters.map((c, i) => (
              <Reveal key={i} delay={i * 0.08}>
                <div className="border-t border-[#0A1128]/15 py-10 md:py-12 group">
                  <div className="flex items-start gap-6 md:gap-10">
                    <span className="font-display text-[#D4AF37] text-2xl md:text-3xl leading-none pt-1">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <div>
                      <h3 className="font-display text-2xl md:text-3xl text-[#0A1128] tracking-tight group-hover:text-[#1D3557] transition-colors">{c.title}</h3>
                      <p className="mt-4 text-base md:text-lg text-[#4B5563] leading-relaxed">{c.body}</p>
                    </div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
